// Mirror of shared-utils/complianceConstants.ts — CRA's ModuleScopePlugin
// blocks src→shared-utils imports, so the frontend keeps a local literal
// and a contract test (enrollmentReadiness.test.ts) pins the value at 3.
// If you change one, change the other.
export const MIN_NUMBER_REFERENCES = 3;

// The in-app, publicly accessible Terms of Service page (src/pages/TermsOfServiceScreen,
// route "/terms"). Relative so it resolves to the current origin in every env; the
// absolute prod URL (https://www.app.emergecareer.com/terms) is what the Twilio A2P
// 10DLC campaign references. Replaced the old Backblaze PDF so the public Terms live
// at a stable in-app URL alongside the Privacy Policy page.
export const TERMS_OF_SERVICE = "/terms";
// The in-app, publicly accessible Privacy Policy page (src/pages/PrivacyPolicyScreen,
// route "/privacy"). Relative so it resolves to the current origin in every env; the
// absolute prod URL (https://www.app.emergecareer.com/privacy) is what the Twilio A2P
// 10DLC campaign references. Replaced the old Backblaze PDF, which lacked the SMS
// opt-in / no-third-party-sharing language carriers require (TCR error 30908).
export const PRIVACY_POLICY = "/privacy";
// TODO: move this to an env var
export const DOMAIN_URL =
  process.env.NODE_ENV === "production"
    ? "https://www.app.emergecareer.com"
    : "http://localhost:3000";

// Always-production origin for student-facing links a coach pastes into an SMS
// or email (Success Queue checklists). Unlike DOMAIN_URL it never resolves to
// localhost — a link sent to a student must work from their phone.
export const STUDENT_APP_ORIGIN = "https://www.app.emergecareer.com";

export const CLP_ID = "55529691";
export const CONDITIONAL_ACCEPTANCE_LESSON_URL =
  "https://f004.backblazeb2.com/file/emerge-courses/CDL/videos/admissions/ConditionalAcceptanceVideo.mp4";
export const SUCCESS_PLAN_EXPLAINED_URL =
  "https://f004.backblazeb2.com/file/emerge-courses/CDL/videos/admissions/SuccessPlanExplained.mp4";

export const SSN_VIDEO_EXPLANATION =
  "https://f004.backblazeb2.com/file/emerge-courses/CDL/videos/admissions/WhySSN.mp4";

export const DRIVER_LICENSE_VIDEO_EXPLANATION =
  "https://f004.backblazeb2.com/file/emerge-courses/CDL/videos/admissions/WhyDriver_sLicense.mp4";

export const ACTION_CODE_REDIRECT_URL = `${DOMAIN_URL}/partners/dashboard`;

export const SKILLS_TRAINING_ORIENTATION_VIDEO =
  "https://f004.backblazeb2.com/file/emerge-courses/CDL/videos/Skills+Training/CDL+Yard+Orientation.mp4";

export const SKILLS_TRAINING_ORIENTATION_QUIZ_ID = "V_Mj0cyPSHumzBoy32ffuQ";

export const AIR_BRAKES_ILLUSTRATION_IMAGE_URL =
  "https://f004.backblazeb2.com/file/emerge-courses/assets/AirBrakes.jpg";
export const PRE_TRIP_ILLUSTRATION_IMAGE_URL =
  "https://f004.backblazeb2.com/file/emerge-courses/assets/Pre-Trip.jpg";
